import { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { getQboStatus, getQboConnectUrl } from '../services/api';
import { useToken } from '../hooks/useToken';

export default function Admin() {
  const getToken = useToken();
  const [connected, setConnected] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);
  const [connecting, setConnecting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getToken()
      .then((t) => getQboStatus(t))
      .then((res) => setConnected(res.connected))
      .catch((e: Error) => setError(e.message))
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleConnect() {
    setConnecting(true);
    setError(null);
    try {
      const token = await getToken();
      const { url } = await getQboConnectUrl(token);
      window.location.href = url;
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to get connect URL');
      setConnecting(false);
    }
  }

  return (
    <Layout pageTitle="Admin">
      <div className="max-w-md">
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-sm font-semibold text-gray-900 mb-4">QuickBooks Online Connection</h2>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
              {error}
            </div>
          )}

          {loading ? (
            <p className="text-sm text-gray-400">Checking connection status...</p>
          ) : connected === true ? (
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-green-500 flex-shrink-0" />
              <span className="text-sm font-medium text-green-700">QuickBooks Connected</span>
            </div>
          ) : (
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <span className="w-2.5 h-2.5 rounded-full bg-yellow-400 flex-shrink-0" />
                <span className="text-sm font-medium text-yellow-700">Not Connected</span>
              </div>
              <p className="text-sm text-gray-500">
                Connect QuickBooks Online to enable automatic bill creation and payment tracking.
              </p>
              <button
                onClick={handleConnect}
                disabled={connecting}
                className="px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg disabled:opacity-50"
              >
                {connecting ? 'Redirecting...' : 'Connect QuickBooks'}
              </button>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
